import React from "react";
import { useIntl } from "react-intl";

type CustReserveItemsProps = {
  items: any[];
};

export default function CustReserveItems({
  items = [],
}: CustReserveItemsProps) {
  const { formatMessage } = useIntl();

  return (
    <>
      <h4>{formatMessage({ id: "hyvendor.menu.reservedlist" })}:</h4>
      <div className="scroll">
        {items !== null &&
          items.map((item, i) => {
            return (
              <section key={i} className="Item extension">
                <div className="inner">
                  <div className="status">&nbsp;</div>
                  <div className="list">
                    {item.keepdate !== "" && (
                      <div className="date">
                        {formatMessage({ id: "hyvendor.column.keepdate" })}:
                        {item.keepdate}
                      </div>
                    )}
                    {item.keepdate === "" && (
                      <div className="date">
                        {formatMessage({ id: "hyvendor.column.vailddate" })}:
                        {item.vailddate}
                      </div>
                    )}
                    <ul>
                      <li>
                        <p>{item.title}</p>
                        <span className="currently">
                          <span className="now">{item.status_name}</span>
                          <span className="date">
                            {formatMessage({ id: "hyvendor.column.bookorder" })}
                            :{item.bookorder}
                          </span>
                        </span>
                        <span className="bar-code">
                          {formatMessage({ id: "hyvendor.column.barcode" })}:
                          {item.barcode}
                        </span>
                        <span className="call-number">
                          {formatMessage({ id: "hyvendor.column.callnumber" })}:
                          {item.callnumber}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            );
          })}
      </div>
    </>
  );
}
